import { FormBuilder } from '@/components/formBuilder';
import { templatesCategoryConfig } from '@/constants/templates-category';
import { useGetTemplatesVariablesQuery } from '@/store/query/email-templates-settings';
import { selectUsers } from '@/store/users/selectors';
import { Flex } from '@chakra-ui/react';
import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFormWrapperConfig } from './emailHelper';

export const Email = memo(
  ({
    formRef = null,
    observFunc = () => {},
    activity = {},
    onTemplateSelect = () => {},
  }) => {
    const [selectedCandidateTemplate, setSelectedCandidateTemplate] = useState(
      {}
    );
    const [selectedInterviewerTemplate, setSelectedInterviewerTemplate] =
      useState({});
    const { candidate_comm_template, reviewer_comm_template } = activity;
    const canIntValues = candidate_comm_template?.body || '';
    const revIntValues = reviewer_comm_template?.body || '';

    const initialValues = {
      candidateEmailEditor: activity?.id ? canIntValues : '',
      interviewerEmailEditor: activity?.id ? revIntValues : '',
    };
    const interviewerView = templatesCategoryConfig.interviewer_notice.view;
    const { data: { variables: interviewerVariables = [] } = {} } =
      useGetTemplatesVariablesQuery({ params: { view: interviewerView } });

    const candidateView =
      templatesCategoryConfig.candidate_interview_notice.view;
    const { data: { variables: candidateVariables = [] } = {} } =
      useGetTemplatesVariablesQuery({ params: { view: candidateView } });

    const users = useSelector(selectUsers);

    const formConfig = [
      getFormWrapperConfig({
        preText: 'candidate',
        formRef,
        users,
        title: `Candidate's calendar invite`,
        variables: candidateVariables,
        template: selectedCandidateTemplate,
        selectOnChange: (template) => {
          setSelectedCandidateTemplate(template);
          onTemplateSelect({ type: 'candidate', template });
        },
        type: 'candidate_interview_notice',
        setDefault: activity?.id ? false : true,
      }),
      getFormWrapperConfig({
        preText: 'interviewer',
        formRef,
        users,
        title: `Interviewer's calendar invite`,
        variables: interviewerVariables,
        template: selectedInterviewerTemplate,
        selectOnChange: (template) => {
          setSelectedInterviewerTemplate(template);
          onTemplateSelect({ type: 'interviewer', template });
        },
        type: 'interviewer_notice',
        setDefault: activity?.id ? false : true,
      }),
    ];

    return (
      <Flex maxH="100%" flexDir="column">
        <FormBuilder
          config={formConfig}
          formRef={formRef}
          initialValues={initialValues}
          showCustomError={false}
          isObserveEnabled={true}
          observFunc={observFunc}
        />
      </Flex>
    );
  }
);

Email.displayName = 'Email';
